import { Tooltip } from '@mui/material';
import { Axis3d } from 'lucide-react';
import { useIntl } from 'react-intl';

/**
 * Marks a listed annotation placed on a plane that is not one of its image's
 * own slices: the picture there is interpolated between slices while the
 * values are not. `labelId` names the message saying what that means for the
 * annotation at hand. A row is what a reader comes back to, long after any
 * notice shown at placement.
 */
export default function ObliquePlaneMarker({ labelId }: { labelId: string }) {
    const intl = useIntl();
    const label = intl.formatMessage({ id: labelId });
    return (
        <Tooltip title={label} placement="left">
            <Axis3d size={15} aria-label={label} />
        </Tooltip>
    );
}
